/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';
import type { DatabaseTextPageBlock } from './DatabaseTextPageBlock';
import {
    DatabaseTextPageBlockFromJSON,
    DatabaseTextPageBlockFromJSONTyped,
    DatabaseTextPageBlockToJSON,
} from './DatabaseTextPageBlock';

/**
 * 
 * @export
 * @interface DatabaseTitlePageBlock
 */
export interface DatabaseTitlePageBlock extends DatabaseTextPageBlock {
}

/**
 * Check if a given object implements the DatabaseTitlePageBlock interface.
 */
export function instanceOfDatabaseTitlePageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTitlePageBlockFromJSON(json: any): DatabaseTitlePageBlock {
    return DatabaseTitlePageBlockFromJSONTyped(json, false);
}

export function DatabaseTitlePageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTitlePageBlock {
    return json;
}

export function DatabaseTitlePageBlockToJSON(value?: DatabaseTitlePageBlock | null): any {
    return value;
}

